// components/ThemeLoader.jsx
import { useEffect } from 'react';

const ThemeLoader = () => {
  useEffect(() => {
    const loadTheme = async () => {
      const theme = process.env.REACT_APP_THEME || 'default';
      
      if (theme === 'green' || document.location.host.indexOf(".2do.homologa.") > -1 || document.location.host.indexOf("localhost") > -1) {
        await import('../../styles/mexx-variables-redesign.css');
      } else {
        await import('../../styles/mexx-variables.css');
      }
    };

    loadTheme();
  }, []);

  return null;
};

export default ThemeLoader;